<template>
  <v-dialog v-model="isVisible" max-width="800px" @click:outside="$emit('callback-cancel')" @keydown.esc="$emit('callback-cancel')">
    <v-card class="mx-auto">
      <v-system-bar>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('callback-cancel')">mdi-close</v-icon>
      </v-system-bar>
      <v-card-title>※ 대기 목록에 1개 이상이 남아있게 되면 목록에 “대기중”으로 보여집니다. <br /> 승인 또는 거절을 전부 체크해주세요.</v-card-title>
      <v-card-text>
        <v-container>
          <article class="tableWrap">
            <div class="tableBtnBx">
              <p>
                분과 목록
              </p>
            </div>
            <div class="tableBx">
              <v-data-table
                  id="departmentTable"
                  item-key="groupId"
                  :hide-default-footer="true"
                  disable-pagination
                  :headers="departmentHeader"
                  :items="departments"
                  class="elevation-1"
              >
                <template v-slot:item.joinState="{value}">
                  {{ value === 'STATE_REQUEST' ? '대기' : value === 'STATE_APPROVAL' ? '승인' : '거절'}}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn color="primary" small dark style="margin-right: 3px;" @click="updateState('STATE_REQUEST', item.groupId)">대기</v-btn>
                  <v-btn color="success" small dark style="margin-right: 3px;" @click="updateState('STATE_APPROVAL', item.groupId)">승인</v-btn>
                  <v-btn color="warning" small dark @click="updateState('STATE_DENIED', item.groupId)">거절</v-btn>
                </template>
              </v-data-table>
            </div>
          </article>
          <article class="tableWrap">
            <div class="tableBtnBx">
              <p>
                동호회 목록
              </p>
            </div>
            <div class="tableBx">
              <v-data-table
                  id="clubTable"
                  item-key="groupId"
                  :hide-default-footer="true"
                  disable-pagination
                  :headers="clubHeader"
                  :items="clubs"
                  class="elevation-1"
              >
                <template v-slot:item.joinState="{value}">
                  {{ value === 'STATE_REQUEST' ? '대기' : value === 'STATE_APPROVAL' ? '승인' : '거절'}}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn color="primary" small dark style="margin-right: 3px;" @click="updateState('STATE_REQUEST', item.groupId)">대기</v-btn>
                  <v-btn color="success" small dark style="margin-right: 3px;" @click="updateState('STATE_APPROVAL', item.groupId)">승인</v-btn>
                  <v-btn color="warning" small dark @click="updateState('STATE_DENIED', item.groupId)">거절</v-btn>
                </template>
              </v-data-table>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#666" dark @click="$emit('callback-cancel')">닫기</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </article>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import userApi from "@/api/UserApi";
import _ from 'lodash';

export default {
  name: "UserGroup",
  components: {
  },
  props: {
    isVisible: Boolean,
    item: Object
  },
  watch: {
    item: {
      handler(nv) {

        this.user = _.cloneDeep(nv);
        this.departments = this.user?.departmentGroup??[];//.filter(e => e.joinState === 'STATE_REQUEST');
        this.clubs = this.user?.clubGroup??[];//.filter(e => e.joinState === 'STATE_REQUEST');

      },
      deep: true
    }
  },
  data: () => ({
    user:{},
    departments:[],
    clubs:[],
    departmentHeader:[
      {text: '분과', value: 'groupName', sortable: false, align: 'center'},
      {text: '상태', value: 'joinState', sortable: false, align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    clubHeader:[
      {text: '동호회', value: 'groupName', sortable: false, align: 'center'},
      {text: '상태', value: 'joinState', sortable: false, align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    isModify:false,
    errorMessages:''
  }),
  methods: {
    async updateState(state, groupId) {

      try {

        userApi.updateUserGroupState(state, groupId, this.user.userId).then(() => {
          // this.departments = this.departments.filter(g => g.groupId !== groupId);
          // this.clubs = this.clubs.filter(g => g.groupId !== groupId);
          // if(this.departments.length === 0 && this.clubs.length === 0) {
          //   this.$emit('callback-cancel');
          // }
          this.departments?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);
          this.clubs?.filter(g => g.groupId === groupId)?.forEach(g => g.joinState = state);
          this.$emit('callback-changed', this.item, groupId, state);
        });

      } catch (error) {
        alert(error.response.data.message);
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>
</style>